export default "__VITE_ASSET__BdlqI_Q9__"